export default function parseDateWithoutTimezone(dateString) {
    const [year, month, day] = dateString.split('-').map(Number); // Split into parts
    return new Date(year, month - 1, day); // Create Date object (month is 0-indexed)
}